export const categoryMenuSearchBoxPlaceholderText = "xUb";
export const categoryMenuNewCategoryTooltipText = "yUb";
export const categoryMenuNewCategoryText = "zUb";
export const categoryMenuAllCategoriesTooltip = "AUb";
export const categoryMenuAllCategoriesText = "BUb";
export const categoryMenuClearCategoriesText = "CUb";
export const categoryMenuClearCategoriesTooltipText = "DUb";
export const categoryMenuManageCategoriesTooltipText = "EUb";
export const categoryMenuManageCategoriesText = "FUb";
export default {categoryMenuSearchBoxPlaceholderText,categoryMenuNewCategoryTooltipText,categoryMenuNewCategoryText,categoryMenuAllCategoriesTooltip,categoryMenuAllCategoriesText,categoryMenuClearCategoriesText,categoryMenuClearCategoriesTooltipText,categoryMenuManageCategoriesTooltipText,categoryMenuManageCategoriesText};